import RechargeHistoryContainer from './RechargeHistoryContainer'

const RechargeHistory = () => {
  return (
    <div className='page-body'>
      <RechargeHistoryContainer />
    </div>
  )
}

export default RechargeHistory